import * as React from "react";
import { Jumbotron } from "react-bootstrap";

export default function FluidJumbotron(props) {
  switch (props.variant) {
    case "basic":
      return <Jumbotron className="centered-jumbotron"></Jumbotron>;
    case "withBackground":
      return (
        <Jumbotron
          className="centered-jumbotron"
          style={{
            background: "url(" + props.background + ") no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="with-image">{props.children}</div>
        </Jumbotron>
      );
    case "divided":
      return (
        <Jumbotron className="divided-jumbotron">
          <div className="xCol">{props.children[0]}</div>
          <div className="yCol">{props.children[1]}</div>
        </Jumbotron>
      );
    default:
      return (
        <Jumbotron className="centered-jumbotron">{props.children}</Jumbotron>
      );
  }
}
